/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemUnauthorized } from './ProblemUnauthorized';

export const UnauthorizedProblems: core.serialization.Schema<
    serializers.UnauthorizedProblems.Raw,
    Truvity.UnauthorizedProblems
> = core.serialization
    .union('type', {
        '/unauthorized': ProblemUnauthorized,
    })
    .transform<Truvity.UnauthorizedProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace UnauthorizedProblems {
    export type Raw = UnauthorizedProblems.Unauthorized;

    export interface Unauthorized extends ProblemUnauthorized.Raw {
        type: '/unauthorized';
    }
}
